// Classes.
import {AthleteGeneralInfoItem} from '../types/athlete-general-info.item';
import {RecordBaseItem} from '../types/record-base.item';

// Services.
import {FactoryService} from '../../wa-services/factory-service';
import {WaHelperService} from '../../wa-services/wa-helper-service';


export class RecordTeamItem extends RecordBaseItem {

  public athlete: AthleteGeneralInfoItem;

  constructor(rawRecordItem: any,
    protected factory: FactoryService,
    protected helper: WaHelperService) {
    super(rawRecordItem, factory);
  }

  getLabel(): string {
    return this.helper.nocToCountryName(this.noc);
  }

  getPicture(): string {
    return this.helper.nocToFlagUrl(this.noc, 'large');
  }

  getSubjectId(): any {
    return this.noc;
  }
}